import { fbt } from 'fbtee'
import { History, Music, UserRound } from 'lucide-react'
import { useTransitionNavigate } from '../../lib/viewTransition'
import { ProfileHero } from '../../components/profile/ProfileHero'
import { DashedButton } from '../../components/DashedButton'
import { Button } from '../../components/ui/button'
import { SelfProfileActions } from './SelfProfileActions'

export function GuestProfileHero() {
  const navigate = useTransitionNavigate()
  return (
    <ProfileHero
      avatar={
        <div className="flex size-24 items-center justify-center rounded-full bg-muted">
          <UserRound className="size-10 text-muted-foreground" />
        </div>
      }
      actions={
        <>
          <Button onClick={() => navigate('/login')} className="h-9 flex-1">
            {fbt('Log in', 'Log in button on the guest profile page')}
          </Button>
          <SelfProfileActions />
        </>
      }
    >
      <h2 className="text-xl font-semibold text-muted-foreground">
        <fbt desc="Placeholder name shown on profile page for unauthenticated users">No account yet</fbt>
      </h2>
      <p className="mt-1 text-sm text-muted-foreground">
        <fbt desc="Subtitle on the guest profile page explaining what logging in unlocks">Log in to save your interests and connect with friends.</fbt>
      </p>
    </ProfileHero>
  )
}

/** What a guest's empty Events/Artists tab would hold once they have an account. */
export function GuestProfileUpsell({ kind }: { kind: 'events' | 'artists' }) {
  const navigate = useTransitionNavigate()
  const Icon = kind === 'events' ? History : Music
  return (
    <DashedButton onClick={() => navigate('/login')} className="p-4 text-left">
      <div className="flex items-start gap-3">
        <div className="shrink-0 rounded-full bg-primary/10 p-2 text-primary">
          <Icon className="size-5" />
        </div>
        <div className="min-w-0 flex-1 space-y-1">
          <p className="text-base font-semibold">
            {kind === 'events'
              ? fbt('Keep your festival history', 'Title of the guest upsell on the profile Events tab')
              : fbt('Follow your artists', 'Title of the guest upsell on the profile Artists tab')}
          </p>
          <p className="text-sm text-muted-foreground">
            {kind === 'events'
              ? fbt(
                  'Log in and the festivals and parties you go to collect here.',
                  'Body of the guest upsell on the profile Events tab',
                )
              : fbt(
                  'Log in, heart artists and see when they play near you.',
                  'Body of the guest upsell on the profile Artists tab',
                )}
          </p>
        </div>
      </div>
    </DashedButton>
  )
}
